import React, { useEffect, useContext } from 'react';
import { AuthContext } from '../context/AuthContext';
import { useNavigate, useLocation } from 'react-router-dom';

const Logout = () => {
    const { logout } = useContext(AuthContext);
    
    const navigate = useNavigate();
    const location = useLocation();
    const from = location.state?.from?.pathname || '/';

    const handleLogout = async () => {
    try {
        await logout();
        navigate(from, { replace: true });
    } catch (error) {
        alert('Logout failed: ' + error.message);
    }
    };

    useEffect(() => {
        handleLogout();
    },[]);

    return (
        <div></div>
    );
};

export default Logout;